import { jsx } from "panel";
import range from "lodash/range";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { WarningEl } from "common/components/warning";
import { WarningTheme } from "common/components/warning/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { CollapsibleTheme, SectionEl } from "common/components/section";
import { TextHighlightEl } from "common/components/text-highlight";
import { SpinnerEl } from "common/components/spinner";
import { QueryBlockEl } from "common/query-builder/query-block";
import { ProfileActivityPropertiesEl } from "./activity-properties";
export function template() {
  const isLoading = this.state.loading.initial || this.state.loading.eventDefinitions || this.state.loading.propertyDefinitions;
  const userActivity = this.helpers.getUserActivityDisplay();
  return /* @__PURE__ */ jsx("div", {
    sel: ".profile-activity",
    class: { "sidebar-mode": this.attr(`sidebar-mode`) }
  }, !this.attr(`sidebar-mode`) && /* @__PURE__ */ jsx("div", {
    sel: ".title-bar"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".activity-title"
  }, "Activity Feed"), /* @__PURE__ */ jsx("div", {
    sel: ".filters-section"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".view-insights",
    attrs: {
      theme: ButtonTheme.Secondary,
      icon: `line`
    },
    on: { click: this.helpers.viewInInsights }
  }, "View in Insights"), /* @__PURE__ */ jsx(QueryBlockEl, {
    attrs: {
      "data-key": `time`,
      "dropdown-alignment": `right`,
      "max-data-history-days": this.attr(`history-limit-days`),
      "project-id": this.helpers.getProjectId(),
      "workspace-id": this.helpers.getWorkspaceId(),
      selected: JSON.stringify(this.state.dateRange),
      "selector-type": `button`,
      "selector-icon": `calendar`,
      "track-name": this.helpers.REPORT_NAME,
      "project-as-of-date": this.attr(`project-as-of-date`),
      type: `time`
    },
    on: {
      select: this.helpers.handleDateRangeSelected,
      track: this.helpers.handleQueryBuilderBlockTrack
    }
  }), /* @__PURE__ */ jsx(QueryBlockEl, {
    attrs: {
      type: `events`,
      "data-key": `event`,
      "exclude-custom-events": true,
      "data-group-id": this.attr(`data-group-id`),
      "dropdown-alignment": `right`,
      label: `Hide Events`,
      multiple: true,
      "project-id": this.helpers.getProjectId(),
      selected: this.helpers.getSelectedHiddenEvents(),
      inverted: this.state.includedEvents.length > 0,
      "selector-icon": `eye-hide`,
      "selector-type": `button`,
      "show-all-events": true,
      "track-name": this.helpers.REPORT_NAME,
      "workspace-id": this.helpers.getWorkspaceId()
    },
    on: {
      select: this.helpers.updateEventFilter,
      track: this.helpers.handleQueryBuilderBlockTrack
    }
  }))), !this.state.error && isLoading && /* @__PURE__ */ jsx("div", {
    sel: ".mp-panel-section"
  }, range(10).map((i) => /* @__PURE__ */ jsx("div", {
    sel: ".mp-skeleton-header",
    key: i
  }))), this.state.error && !isLoading && /* @__PURE__ */ jsx(WarningEl, {
    attrs: {
      "body-text": `We were unable to display this user's activity due to an error. Please try again later.`,
      "header-text": `Unable to Display Activity Feed`,
      theme: WarningTheme.Error
    }
  }), !this.state.error && !isLoading && /* @__PURE__ */ jsx(null, null, userActivity.length === 0 && /* @__PURE__ */ jsx("div", {
    sel: ".no-data-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".no-data-image"
  }), "No activity in the time period specified (", this.state.dateRange.getDisplayText(), ")"), userActivity.length > 0 && /* @__PURE__ */ jsx(null, null, userActivity.map((dayGroup) => /* @__PURE__ */ jsx("div", {
    sel: ".day-header"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: {
      icon: `calendar`
    }
  }), dayGroup.dayHeader, /* @__PURE__ */ jsx("div", {
    sel: ".day-activities"
  }, dayGroup.activities.map((activity) => {
    const { eventName, eventGroup } = activity;
    const { time, insertId } = eventGroup[0];
    const hasBeenRendered = this.state.renderedGroupings.has(insertId);
    return /* @__PURE__ */ jsx("div", {
      sel: ".activity-event-wrapper"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".activity-time"
    }, this.helpers.getDisplayTime(time)), /* @__PURE__ */ jsx("div", {
      sel: ".activity-name"
    }, /* @__PURE__ */ jsx(SectionEl, {
      attrs: {
        "enable-row-click": true,
        "is-closed": true,
        theme: CollapsibleTheme.INLINE
      },
      on: {
        change: (ev) => this.helpers.handleExpandGrouping(ev, activity)
      }
    }, /* @__PURE__ */ jsx("div", {
      sel: ".activity-event-title",
      attrs: { slot: `title` }
    }, eventName, eventGroup.length > 1 && /* @__PURE__ */ jsx(TextHighlightEl, {
      attrs: { text: eventGroup.length }
    })), hasBeenRendered && eventGroup.length === 1 && /* @__PURE__ */ jsx("div", {
      sel: ".detail-pane"
    }, /* @__PURE__ */ jsx(ProfileActivityPropertiesEl, {
      attrs: {
        "utc-offset": this.attr(`utc-offset`),
        "mixpanel-properties": eventGroup[0].mixpanelProperties,
        "user-defined-event-properties": eventGroup[0].userDefinedEventProperties,
        "event-name": eventName,
        time
      }
    })), hasBeenRendered && eventGroup.length > 1 && /* @__PURE__ */ jsx("div", {
      sel: ".event-group-pane"
    }, /* @__PURE__ */ jsx(EventGroup, {
      eventGroup,
      getDisplayTime: this.helpers.getDisplayTime,
      trackCollapsibleChange: this.helpers.trackCollapsibleChange,
      utcOffset: this.attr(`utc-offset`)
    })))));
  })))), /* @__PURE__ */ jsx("div", {
    sel: ".activity-footer"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".since-date-wrapper"
  }, "Since ", this.helpers.getLastVisibleFromDate()), /* @__PURE__ */ jsx("div", {
    sel: ".show-more-wrapper"
  }, this.state.loading.moreEvents ? /* @__PURE__ */ jsx(SpinnerEl, null) : this.state.enableShowMoreButton ? /* @__PURE__ */ jsx(ButtonEl, {
    attrs: { theme: ButtonTheme.Secondary },
    on: { click: this.helpers.handleShowMore }
  }, "Show more") : null)))));
}
function EventGroup({ eventGroup, getDisplayTime, trackCollapsibleChange, utcOffset }) {
  return eventGroup.map(({ mixpanelProperties, eventDisplayName, time, userDefinedEventProperties }) => /* @__PURE__ */ jsx("div", {
    sel: ".grouped-event-row"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".activity-ungrouped-time"
  }, getDisplayTime(time)), /* @__PURE__ */ jsx("div", {
    sel: ".activity-ungrouped-name"
  }, /* @__PURE__ */ jsx(SectionEl, {
    attrs: {
      "enable-row-click": true,
      "hide-caret": true,
      "is-closed": true,
      theme: CollapsibleTheme.INLINE
    },
    on: {
      change: (ev) => trackCollapsibleChange(ev, eventDisplayName, time, false)
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".expand-event-properties",
    attrs: { slot: `title` }
  }, eventDisplayName), /* @__PURE__ */ jsx("div", {
    sel: ".sub-event-pane"
  }, /* @__PURE__ */ jsx(ProfileActivityPropertiesEl, {
    attrs: {
      "utc-offset": utcOffset,
      "event-name": eventDisplayName,
      "mixpanel-properties": mixpanelProperties,
      "user-defined-event-properties": userDefinedEventProperties,
      time
    }
  }))))));
}
